// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__8qVfO","accordion__item":"accordion_accordion__item__jAj6y"};